interface Props {
  className?: string;
  isGradient?: boolean;
}

const LogoImageMini = ({ className, isGradient }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="white"
    viewBox="0 0 252.35 185.46"
  >
    <defs>
      <linearGradient id="linearGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#EF426F', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#514689', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <g fill={isGradient ? 'url(#linearGradient)' : undefined}>
      <path d="M219.54,0c-15.8,0-29,11.18-32.11,26.05c-0.46,2.18-0.7,4.44-0.7,6.75c0,16.27,11.84,29.77,27.37,32.36 c1.77,0.3,3.58,0.45,5.43,0.45c18.12,0,32.8-14.69,32.8-32.8C252.35,14.69,237.66,0,219.54,0z" />
      <path d="M173.48,102.91c-22.44,0-40.64-18.2-40.64-40.64c0-2.06,0.15-4.09,0.45-6.07l-0.05-0.01 c0.37-2.42,0.56-4.9,0.56-7.43C133.81,21.83,111.97,0,85.04,0C58.11,0,36.27,21.83,36.27,48.77c0,3.79,0.43,7.47,1.25,11.01h0 c1.28,5.53,1.96,11.29,1.96,17.2c0,24.24-11.36,45.82-29.04,59.72l0.01,0.02C4.09,141.72,0,149.48,0,158.19 c0,15.06,12.21,27.27,27.27,27.27c15.06,0,27.27-12.21,27.27-27.27c0-2.84-0.43-5.58-1.24-8.15l0.08-0.03 c-1.19-3.82-1.83-7.88-1.83-12.08c0-21.3,16.38-38.77,37.23-40.5c1.12-0.09,2.26-0.14,3.41-0.14c22.44,0,40.64,18.2,40.64,40.64 c0,0.88-0.03,1.75-0.08,2.61l0.19,0.01c-0.07,0.99-0.11,1.99-0.11,3.01c0,22.44,18.2,40.64,40.64,40.64 c22.44,0,40.64-18.2,40.64-40.64S195.92,102.91,173.48,102.91z" />
    </g>
  </svg>
);

export default LogoImageMini;
